module.exports = __webpack_public_path__ + "img/良好.1e791a03.png";